import { isLiveMallClub } from '@/constants/systemType'
import { isEmpty } from 'lodash-es'

const minNameLength = 2
const maxNameLength = isLiveMallClub ? 64 : 20

export const handleNickNameFormatRegex = (value: string) => {
  const isValidLength = !value || (value?.length >= minNameLength && value?.length <= maxNameLength)

  const isMatchSymbol = !isEmpty(
    value?.match(/[~`!@#$%^&*()\-=+\]}[{'"?.>,<\\|_～！＠＃＄％＾＆＊（）＿＋｜』『“：？。，、》〉＞《〈＜÷／〃”；＼」】］｝「【〖｛×＝——·﹋}‘]+/),
  )

  return !isMatchSymbol && isValidLength
}

export const handleFullNameFormatRegex = (value: string) => {
  const isMatchNumber = !isEmpty(value?.match(/[0-9]/))

  const isValidLength = !value || (value?.length >= minNameLength && value?.length <= maxNameLength)

  const isMatchSymbol = !isEmpty(
    value?.match(/[~`!@#$%^&*()\-=+\]}[{'"?.>,<\\|_～！＠＃＄％＾＆＊（）＿＋｜』『“：？。，、》〉＞《〈＜÷／〃”；＼」】］｝「【〖｛×＝——·﹋}‘]+/),
  )

  // eslint-disable-next-line no-control-regex
  const isMatchEmoji = !isEmpty(value?.match(/[^\u0000-\uffff]+/))

  return !isMatchNumber && isValidLength && !isMatchSymbol && !isMatchEmoji
}
